import { useCallback, useEffect } from 'react';
import { Bookmark } from 'react-bootstrap-icons';
import { useLocation, useParams } from 'react-router-dom';

import CoursesList from '@/components/shared/CoursesList';
import EmptyState from '@/components/shared/EmptyState';
import HorizontalList from '@/components/shared/HorizontalList';
import Wrapper from '@/components/shared/Wrapper';
import { useSocketShouldUpdateCourses } from '@/hooks/useSocketUpdateCourses';
import { IPaginationParams } from '@/interfaces/pagination';
import { packageApi, useGetPackagesQuery } from '@/services/package';

import Card from '../MyCourses/Card';

const CoursesFromPackage = () => {
  const { state } = useLocation();
  const hasUpdated = useSocketShouldUpdateCourses();

  const [refetch, { isFetching, data: response }] = packageApi.endpoints.getPackageCourses.useLazyQuery({});
  const { hash } = useParams();
  const { isLoading: arePackagesFetching } = useGetPackagesQuery({ page: 1, size: 20 });

  useEffect(() => {
    refetch({ page: 1, size: 20, hash });
  }, [hasUpdated, refetch, hash]);

  const onReachedEnd = useCallback(
    (params: IPaginationParams) => {
      refetch({
        ...params,
        hash
      });
    },
    [refetch, hash]
  );

  const onComponentLoad = useCallback(() => {
    refetch({ page: 1, size: 20, hash });
  }, [refetch, hash]);

  if (response?.total_rows === 0) {
    return (
      <Wrapper>
        <EmptyState
          icon={<Bookmark size={48} />}
          title='Seus cursos do pacote aparecerão aqui...'
          description='Aqui você poderá acessar com facilidade todos seus cursos do pacote'
        />
      </Wrapper>
    );
  }

  return (
    <CoursesList
      title={state?.packageTitle}
      onComponentLoad={onComponentLoad}
      onReachPageEnd={onReachedEnd}
      queryProps={{ data: response, isFetching }}
      hasFilter={false}
    >
      <HorizontalList isFetching={isFetching || arePackagesFetching}>
        {response?.data?.map(course => (
          <Card {...course} key={course.id} />
        ))}
      </HorizontalList>
    </CoursesList>
  );
};

export default CoursesFromPackage;
